import * as React from 'react';

import type { W_Job_JobPreview_VM } from 'ab-api/web/job/findByIdForPreview';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

interface Props {
	job: W_Job_JobPreview_VM;
	renderItem: (label: string, value: Nullable<string>, icon?: React.JSX.Element) => React.JSX.Element;
}

export default ({ job, renderItem }: Props) => {
	return (
		<div className="dashboard-card">
			<div className="dashboard-card-header">
				JOB INFO
			</div>
			<div className="dashboard-card-content">
				{renderItem('Job #', job?.details.jobCode)}
				{renderItem('Customer', job?.details.customerCompanyName)}
				{renderItem('Start Date', job?.details.startDate && TimeUtils.formatDate(job.details.startDate))}
				{renderItem('Target Compl', job?.details.targetCompletionDate)}
				{renderItem('Guaranteed Compl', job?.details.guaranteedCompletionDate)}
			</div>
		</div>
	);
};
